import { memo } from "react";
import { Collection } from "ui/support/Resource";
import useApplicationStepStatusAnalytics from "./useApplicationStepStatusAnalytics";
import FieldsStatus from "./FieldsStatus";

const ApplicationStepStatusAnalytics = () => {
    const { getStepFieldsStatuses } = useApplicationStepStatusAnalytics();

    return (
        <Collection
            sx={{
                mt: 4,
                display: 'grid',
                gridTemplateColumns: '1fr auto',
                gap: 2
            }}
            collection={getStepFieldsStatuses()}
            renderResource={([status, props]) => (
                <FieldsStatus
                    {...props}
                    key={status}
                    status={status}
                />
            )}
        />
    );
};

export default memo(ApplicationStepStatusAnalytics);
